import $http from "@/plugins/axios"

export default {
    state: {
        prognosis: [],
    },
    getters: {
        prognosis: state => state.prognosis
    },
    actions: {
        async getPrognosis({ commit }, path) {
            const response = await $http.get(path)
            commit("SET_ITEMS", response.data)
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.prognosis = data
        }
    }
}